module.exports = __webpack_public_path__ + "static/img/vr5.e127af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr5.png
// module id = 9wn4
// module chunks = 1